<div class="tablero-emergencias">
  <app-dashboard-filtros titulo="Emergencias médicas">
    <app-date-picker
      filtros-periodo
      mode="daterange"
      label="Período de las históricas"
      [maxDate]="hoy"
      [(ngModel)]="periodo"
      (ngModelChange)="onPeriodoChange($event)"
    ></app-date-picker>
    <button
      irxBotonIcono
      filtros-acciones
      tooltip="Restaurar el orden original de los paneles"
      (click)="grilla.restaurarOrden()"
    >
      <mat-icon>restart_alt</mat-icon>
    </button>
  </app-dashboard-filtros>

  <!-- Tarjetas de indicador -->
  <div class="stat-cards-fila dashboard-indicadores">
    @for (card of statCards; track card.title) {
      <app-stat-card
        [config]="card"
        [formatAsNumber]="true"
        numberFormat="1.0-0"
      ></app-stat-card>
    }
  </div>

  <!-- Grilla de paneles ordenables -->
  <app-dashboard-grilla
    #grilla
    [(items)]="graficos"
    claveOrden="tablero-emergencias-medicas-orden-graficos"
  >
    <ng-template let-grafico>
      <app-dashboard-panel
        [titulo]="tituloPanel(grafico)"
        [subtitulo]="grafico.tipo === 'mapa' ? subtituloMapa : ''"
        [icono]="grafico.icono"
      >
        @if (!graficoListo(grafico)) {
          <div class="dpanel-vacio" [style.min-height]="grafico.altura">
            <mat-spinner diameter="36"></mat-spinner>
            <p>Cargando…</p>
          </div>
        } @else if (!tieneDatos(grafico)) {
          <div class="dpanel-vacio" [style.min-height]="grafico.altura">
            <mat-icon>{{ grafico.icono }}</mat-icon>
            <p>{{ grafico.sinDatos }}</p>
          </div>
        } @else {
          @switch (grafico.tipo) {
            @case ('line') {
              <app-graficos
                tipo="line"
                [series]="seriesPorFecha"
                [categorias]="categoriasPorFecha"
                [titulo]="''"
                tituloEjeY="Cantidad"
                [altura]="grafico.altura"
                [mostrarLeyenda]="true"
                posicionLeyenda="bottom"
                [mostrarPuntos]="true"
                [mostrarEtiquetas]="false"
                [permitirDecimales]="false"
              ></app-graficos>
            }

            @case ('column') {
              <app-graficos
                tipo="column"
                [series]="seriesTiempos"
                [categorias]="categoriasTiempos"
                [titulo]="''"
                tituloEjeY="Minutos"
                [altura]="grafico.altura"
                [mostrarLeyenda]="true"
                posicionLeyenda="bottom"
                [mostrarEtiquetas]="false"
              ></app-graficos>
            }

            @case ('bar') {
              <app-graficos
                tipo="bar"
                [series]="ranking(grafico.id).series"
                [categorias]="ranking(grafico.id).categorias"
                [titulo]="''"
                [altura]="grafico.altura"
                [mostrarLeyenda]="false"
                [permitirDecimales]="false"
              ></app-graficos>
            }

            @case ('sankey') {
              <!-- app-graficos no regenera ante cambios de `opciones`: se recrea -->
              @for (v of [versionSankey]; track v) {
                <app-graficos
                  tipo="pie"
                  [opciones]="opcionesSankey"
                  [titulo]="''"
                  [altura]="grafico.altura"
                ></app-graficos>
              }
            }

            @case ('tabla-activas') {
              <div class="tabla-scroll-wrapper">
                <app-tabla
                  [columnas]="columnasActivas"
                  [datos]="activas"
                  [paginatorAbajo]="false"
                  [buttonColumns]="false"
                  [fillParent]="false"
                ></app-tabla>
              </div>
            }

            @case ('tabla-tiempos') {
              <div class="tabla-scroll-wrapper">
                <app-tabla
                  [columnas]="columnasTiempos"
                  [datos]="filasTiempos"
                  [paginatorAbajo]="false"
                  [buttonColumns]="false"
                  [fillParent]="false"
                ></app-tabla>
              </div>
            }

            @case ('mapa') {
              @if (mapaHistorico) {
                <app-map-card
                  class="mapa-panel"
                  [config]="mapaHistorico"
                ></app-map-card>
              }
            }

            @default {
              <!-- pie / donut -->
              <app-graficos
                [tipo]="grafico.tipo"
                [datos]="datosPie(grafico.id)"
                [titulo]="''"
                [altura]="grafico.altura"
                [mostrarLeyenda]="true"
                posicionLeyenda="right"
                [mostrarEtiquetas]="false"
              ></app-graficos>
            }
          }
        }
      </app-dashboard-panel>
    </ng-template>
  </app-dashboard-grilla>
</div>
